// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3NYCb","content":"LayoutSettings_content__19g9b"};